<p class="mat-body-2">
  Distinction Information is Dow Confidential - Internal and is not to be shared externally
</p>
